var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcRouteFill = function SvgIcRouteFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.119 5.119C7.42 2.818 8.57 1.667 10 1.667s2.58 1.15 4.882 3.452S18.334 8.57 18.334 10s-1.15 2.58-3.452 4.882S11.43 18.334 10 18.334s-2.58-1.15-4.881-3.452S1.667 11.43 1.667 10s1.15-2.58 3.452-4.881m6.42 1.925a.625.625 0 0 0-.855.912l1.069 1.003H8.89c-.463 0-1.149.125-1.74.523-.623.42-1.108 1.13-1.108 2.185a.625.625 0 1 0 1.25 0c0-.613.256-.944.558-1.148.311-.199.671-.306 1.04-.31h2.863l-1.07 1.002a.625.625 0 0 0 .856.912l2.222-2.083a.626.626 0 0 0 0-.912z",
    clipRule: "evenodd"
  })));
};
export default SvgIcRouteFill;